import Vue from 'vue';

// global components import
import AppFocusLock from '@/components/AppFocusLock.vue';

import VueGtag from 'vue-gtag';
import App from './App.vue';
import router from './router';
import store from './store';
// custom helpers or plugin
// import './helpers/index';
// plugins
import './plugins/amplify';
import './plugins/simplebar';
import './plugins/element-ui';
import './plugins/font-awesome';

// import './assets/plugins/bootstrap';

Vue.use(VueGtag, {
  config: {
    id: 'G-DGVLDR41E1',
    params: {
      page_path: window.location.pathname + window.location.hash,
    },
  },
});

// global components declare
Vue.component('app-focus-lock', AppFocusLock);
Vue.config.productionTip = false;
Vue.prototype.$appName = 'ConnectHub';

const EventBus = new Vue();
Object.defineProperties(Vue.prototype, {
  $eventBus: {
    get() {
      return EventBus;
    },
  },
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
